import { Box } from "@mui/material";
import React, { useState } from "react";
import { apiUploadCoverPhoto, apiUploadProfilePhoto } from "../../api/account";
import { useMutation } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { setAccount_profile_data } from "../../store/contentSlice";
import { RootState } from "../../store/store";

interface BgImageProps {
  sourceCover: any;
  sourceProfile: any;
  account: boolean;
}
const ImageBackground = ({
  sourceCover,
  sourceProfile,
  account,
}: BgImageProps) => {
  const [image_uri, setImage_uri] = useState<File | null>(null); // State to hold the image URI
  const [profile_uri, setProfile_uri] = useState<File | null>(null); // State to hold the image URI
  const [images_container, setImages_container] = useState({
    profile_image: "",
    cover_image: "",
  });
  const account_profile_data = useSelector(
    (state: RootState) => state.content.account_profile_data
  );
  const dispatch = useDispatch();

  const cover_mutation = useMutation({
    mutationFn: (photo: any) => apiUploadCoverPhoto(photo),
    onSuccess: (data) => {
      if (data?.status === "error") {
        if ("details" in data) {
          return;
        }
        return;
      }
      if (data.status === 200) {
        // Update your state with the new cover photo URL
        setImages_container((prev) => ({
          ...prev,
          cover_image: data?.data?.photo_url,
        }));
      }
    },
    onError: (error) => {
      console.error("Fetch process failed", error);
    },
  });
  const profile_mutation = useMutation({
    mutationFn: (photo: any) => apiUploadProfilePhoto(photo),
    onSuccess: (data) => {
      if (data?.status === "error") {
        if ("details" in data) {
          return;
        }
        return;
      }
      if (data.status === 200) {
        // Update your state with the new cover photo URL
        setImages_container((prev) => ({
          ...prev,
          profile_image: data?.data?.photo_url,
        }));
        dispatch(
          setAccount_profile_data({
            id: account_profile_data?.id,
            name: account_profile_data?.name,
            image: data?.data?.photo_url,
            kyced: account_profile_data?.kyced,
            id_uploaded: account_profile_data?.id_uploaded,
          })
        );
      }
    },
    onError: (error) => {
      console.error("Fetch process failed", error);
    },
  });

  const handle_cover_upload = (uri: any) => cover_mutation.mutate(uri);
  const handle_profile_upload = (uri: any) => profile_mutation.mutate(uri);

  const handle_profile_select = (event: any) => {
    const file = event.target.files[0];
    if (file) {
      setProfile_uri(file);
      const url = URL.createObjectURL(file);
      setImages_container((prev) => ({ ...prev, profile_image: url }));
      handle_profile_upload(file);
    }
  };
  const handle_cover_select = (event: any) => {
    const file = event.target.files[0];
    if (file) {
      setImage_uri(file);
      const url = URL.createObjectURL(file);
      setImages_container((prev) => ({ ...prev, cover_image: url }));
      handle_cover_upload(file);
    }
  };

  const handle_profile_click = () => {
    document.getElementById("imageProfileInput")?.click();
  };
  const handle_cover_click = () => {
    document.getElementById("imageCoverInput")?.click();
  };

  return (
    <Box
      sx={{
        background: !!images_container?.cover_image
          ? `url(${images_container.cover_image})`
          : `url(${sourceCover})`,
        width: "100%",
        position: "relative",
        height: 200,
        backgroundSize: "contain",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        zIndex: 1,
      }}
    >
      {account && (
        <Box
          onClick={handle_cover_click}
          sx={{
            background: "#E2F1EB",
            width: 40,
            height: 40,
            borderRadius: "50%",
            padding: "4px",
            display: "flex",
            mx: 3,
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <input
            type="file"
            id="imageCoverInput"
            style={{ display: "none" }}
            accept="image/*"
            onChange={handle_cover_select}
          />
          <img
            alt="i"
            src="/assets/icons/account/camera.png"
            style={{ width: "80%", height: "80%" }}
          />
        </Box>
      )}
      <Box
        sx={{
          position: "absolute",
          width: 120,
          height: 120,
          borderRadius: "50%",
          zIndex: 10,
          border: "2px solid #459173",
          bottom: -60,
          left: 20,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <img
          src={
            !!images_container.profile_image
              ? images_container.profile_image
              : sourceProfile
          }
          width={"100%"}
          height={"100%"}
          style={{ borderRadius: "50%" }}
          alt=""
        />
        {account && (
          <Box
            onClick={handle_profile_click}
            sx={{
              background: "#E2F1EB",
              width: 28,
              height: 28,
              borderRadius: "50%",
              padding: "4px",
              display: "flex",
              mx: 3,
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              position: "absolute",
            }}
          >
            <input
              type="file"
              id="imageProfileInput"
              style={{ display: "none" }}
              accept="image/*"
              onChange={handle_profile_select}
            />
            <img
              alt="i"
              src="/assets/icons/account/camera.png"
              style={{ width: "90%", height: "90%" }}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ImageBackground;
